import { Stack, Flex, Title, useMantineTheme } from "@mantine/core";

import DataDisplay from "./DataDisplay";
import { UseCaseBasicType, UseCaseRunDetails } from "@supportinitiative/common";

export default function MasterDataset({
  useCase,
  masterDataset,
}: {
  useCase: UseCaseBasicType;
  masterDataset: UseCaseRunDetails["masterDataset"];
}) {
  const theme = useMantineTheme();

  return (
    <Stack mt="xs" h="100%" p="xs" bg="#FFF2E0">
      <Flex>
        <Title
          mt="xs"
          order={5}
          py={0}
          px={theme.spacing.sm}
          style={{
            borderLeft: `4px solid ${theme.colors.emerald[0]}`,
          }}
        >
          {useCase.definition.masterDataset.type === "DATASET"
            ? useCase.definition.masterDataset.name
            : "Master Dataset"}
        </Title>
      </Flex>
      <DataDisplay
        data={masterDataset || []}
        links={[]}
        table="master"
        definition={[]}
        height={150}
      />
    </Stack>
  );
}
